import { Injectable } from '@angular/core';
import {
  IUploadPosition,
  IUploadProgress
} from '../models/upload-progress.model';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  public loading: boolean = false;
  public message: string = '';

  /** Subida de archivo en curso; null cuando no hay ninguna. */
  public upload: IUploadProgress | null = null;

  constructor() { }

  /* -------------------------------------------------------------------------- */
  /*                             ANCHOR startUpload                             */
  /* -------------------------------------------------------------------------- */
  // region startUpload
  startUpload(
    fileName: string,
    position: IUploadPosition | null = null
  ): void {

    this.upload = {
      fileName,
      position,
      percent: 0
    };

  }

  /* -------------------------------------------------------------------------- */
  /*                           ANCHOR setUploadPercent                          */
  /* -------------------------------------------------------------------------- */
  // region setUploadPercent
  setUploadPercent(
    percent: number
  ): void {

    if (!this.upload) {
      return;
    }

    this.upload.percent = Math.min(100, Math.max(0, Math.round(percent)));

  }

  /* -------------------------------------------------------------------------- */
  /*                             ANCHOR clearUpload                             */
  /* -------------------------------------------------------------------------- */
  // region clearUpload
  clearUpload(): void {

    this.upload = null;

  }

}
